import SideModal from "/src/components/modal/SideModal/SideModal";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from '/src/components/form/Form';
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import ConversationModalFollowUp from './ConversationModalFollowUp/ConversationModalFollowUp';
import ConversationModalInformationDetails from './ConversationModalInformationDetails/ConversationModalInformationDetails';
import SliderTab from "/src/components/slider/sliderTab/SliderTab";
import "./ConversationDetailsModal.css";

import ConversationService from '../../services/ConversationService';
import { useState } from "react";

const ConversationDetailsModal = NiceModal.create(({ title, data, state, onRefresh }) => {
    const modal = useModal();
    const toast = useToastDispatchContext();
    const { onClose } = useModalHelper(modal);

    const handleClose = () => {
        onClose();
        onRefresh && onRefresh()
    }

    const copyToClipBoard = async (e) => {
        const url = `${location.protocol}//${location.host}${location.pathname}?conversation_id=${data?.instance_id}`
        await navigator.clipboard.writeText(url);
        toast.success('Share your Url' , `The Url of sharing is copied`, 5000);
    }

    const [isSending, setIsSending] = useState(false);

    const mailConvo = async (data) => {
        if (isSending) return;
        try {
            setIsSending(true);
            
            if (!data.messages || data.messages.length === 0) {
                toast.error(
                    "No Conversation to send",
                    "There is no conversation to mail"
                );
                alert("No messages to send");
                return;
            }
            // onClose();
            const conversationId = data.id;
            
            const response = await ConversationService.sendConversationByMail(conversationId);
            const result = response?.[0];
    
            if (result?.success) {
            toast.success(
                "Conversation sent successfully",
                "The conversation has been sent to your email address."
            );
            } else {
                toast.error(
                    "Failed to send conversation",
                    "The conversation could not be sent."
                );
            }
        } catch (error) {
            console.error(error);
            toast.error(
                "Something went wrong",
                "We couldn’t send the conversation. Please try again later."
            );
        }finally {
            setIsSending(false); 
        }
    };

    const itemsConversations = [
        { name: 'Information', component: <ConversationModalInformationDetails data={data} state={state} onClose={handleClose}/> },
        { name: state == 1 ? 'Follow-up' : 'Content', component: <ConversationModalFollowUp data={data} state={state} /> },
    ];
    /*
        const itemsRelaunch = [
            { name: 'Information', component: <ConversationModalInformationDetails data={data} state={state} /> },
            { name: 'Follow-up', component: <ConversationModalFollowUp url={data.url} body={data.body} {...state} /> },
        ];
    */

    return (
        <SideModal id={modal.id} autoClose="true" onClose={handleClose} style={{ width: '550px', zIndex: '1000' }} name="conversation_modal">
            <div>
                <div className="button-leave" id="close_modal_container close_convo_modal_container" onClick={handleClose} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <Form className="form-conversation edit-container">
                <div className="title">
                    <Form.Title>{title}</Form.Title>
                    <span class="icon" onClick={copyToClipBoard}></span>
                    <div className={`send-convo-icon ${isSending ? "disabled" : ""}`} onClick={() => mailConvo(data)} title="Send conversation by email">
                        <i className="fa fa-paper-plane" aria-hidden="true" alt="Send conversation by email" style={{color: "var(--main)"}}></i>
                    </div>
                </div> 
                <Form.Body className="body-editModal-container">
                    <SliderTab name={"slide_conversation_modal_form"} items={itemsConversations} classNameTab="tab-justify" classNameIndicator="space_left_conversation_form_modal" type="tab"></SliderTab>

                    {
                        /*
                        isForRelaunch ? (
                        <SliderTab name={"slide_conversation_modal_form"} items={itemsConversations} classNameTab="tab-justify" classNameIndicator="space_left_conversation_form_modal" type="tab"></SliderTab>
                        ) : (
                        <SliderTab name={"slide_conversation_modal_form"} items={itemsConversations} classNameTab="tab-justify" classNameIndicator="space_left_conversation_form_modal" type="tab"></SliderTab>
                        )
                    */
                    }

                </Form.Body>
            </Form>
        </SideModal>
    )
});


export default ConversationDetailsModal;